import React from "react";

function UserJobTitle(props) {
  const { user } = props;

  return user.job_title && <p className='member-job'>{user.job_title}</p>;
}

export default UserJobTitle;
